
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/colaboradores-uas",
      function () {
        return require("private-next-pages/colaboradores-uas.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/colaboradores-uas"])
      });
    }
  